export enum possibleLeaguesListDisplayStates {
    joined = 'joined',
    available = 'available',
}